import { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Image,
  Text,
  Box,
  Link,
  Button
} from '@chakra-ui/react';
import CopyGreenIcon from '../../assets/copy-green-icon.svg';
import CopySuccessIcon from '../../assets/copy-success-icon.svg';
import FacebookIcon from '../../assets/facebook-icon.svg';
import LinkedinIcon from '../../assets/linkedin-icon.svg';
import RedditIcon from '../../assets/reddit-icon.svg';
import TwitterIcon from '../../assets/twitter-icon.svg';
import WhatsappIcon from '../../assets/whatsapp-icon.svg';
import CloseModalIcon from '../../assets/close-modal-icon.svg';
import VerifiedIcon from '../../assets/verified-icon.svg';
import FoundingCreatorIcon from '../../assets/founding_creator_icon.png';
import ShareArticleIcon from '../../assets/share-article-icon.svg';
import AvatarDefault from '../../assets/small_default_optimized.png';

import {
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';
import { useNavigate } from 'react-router-dom';
import { shareArticle } from '../../apis/article.api';
import Cookies from 'js-cookie';
import DataLayer from '../../utils/data-layer';

function ShareContentModal(props) {
  const {
    userInfo,
    isOpen,
    onClick,
    title,
    description,
    shareUrl,
    titleBtn,
    onClose,
    media,
    bgColorOverlay,
    smallTitle,
    articleId,
    article
  } = props;

  const [isCopy, setIsCopy] = useState(false);
  const navigate = useNavigate();
  const token = Cookies.get(`token`);

  const handleCountShare = async () => {
    if (articleId && token) {
      await shareArticle(articleId);
    }

    // Track article share event
    if (articleId && article) {
      const articleType = article.writingType?.name;
      DataLayer.trackArticleShare(articleType, articleId);
    } else {
      // Track writer share event
      if (userInfo?.username) {
        DataLayer.trackWriterShare(userInfo.username);
      }
    }
  };

  const handleCopy = (value) => async () => {
    try {
      if (!isCopy) {
        setIsCopy(true);
        setTimeout(() => {
          setIsCopy(false);
        }, 3000);
        if (value) navigator.clipboard.writeText(value);
      }
      handleCountShare();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay backgroundColor={bgColorOverlay} />
      <ModalContent maxW={'396px'} px={'15px'} py={5} bgColor={'seasalt-white'} rounded={'12px'}>
        <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
          <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
            <p className="text-xl font-[800]">{title}</p>
            <Image
              className="w-[40px] h-[40px] cursor-pointer"
              src={CloseModalIcon}
              onClick={onClick}
              alt=""
            />
          </div>
        </ModalHeader>
        <ModalBody p={0}>
          <div className="flex flex-col items-center my-6">
            <img src={ShareArticleIcon} className="w-[48px] h-[48px]" alt="" />
            <p className="text-[24px] font-[800] text-growth-green-500 my-2">{smallTitle}</p>
            {userInfo && (
              <div className="flex flex-col gap-2 items-center w-full justify-center">
                <div className="flex gap-2">
                  <img
                    src={userInfo?.imgUrl || AvatarDefault}
                    alt=""
                    className="w-[54px] h-[54px] rounded-full object-cover cursor-pointer"
                    onClick={() => navigate(`/${userInfo?.username}`)}
                  />
                  <div>
                    <div
                      className="flex gap-1 items-center cursor-pointer"
                      onClick={() => navigate(`/${userInfo?.username}`)}
                    >
                      <p className="text-sm font-[600] hover:text-growth-green-500 transition duration-200">
                        {userInfo?.firstName}
                      </p>
                      {userInfo?.isVerifiedAuthor && <img src={VerifiedIcon} alt="" />}
                      {userInfo?.isFoundingCreator && (
                        <img
                          src={FoundingCreatorIcon}
                          alt="Founding Creator"
                          title="Founding Creator"
                          className="w-[24px] h-[24px]"
                        />
                      )}
                    </div>
                    {userInfo?.username && (
                      <span className="font-[600] text-xs text-02-dim-gray">
                        @{userInfo?.username}
                      </span>
                    )}
                  </div>
                </div>
                <p className="text-sm mt-2 italic line-clamp-3">{userInfo?.description}</p>
              </div>
            )}
            <div className="flex items-center gap-3 mt-6">
              <p className="font-[600] text-sm text-black">Share:</p>
              <div className="flex items-center gap-3">
                <FacebookShareButton url={shareUrl} hashtag={'#twygs'} onClick={handleCountShare}>
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    src={FacebookIcon}
                    alt="icon"
                  />
                </FacebookShareButton>
                <TwitterShareButton
                  url={shareUrl}
                  title="Check out this article on Twygs"
                  onClick={handleCountShare}
                >
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    src={TwitterIcon}
                    alt="icon"
                  />
                </TwitterShareButton>
                <LinkedinShareButton
                  url={shareUrl}
                  title="For readers who seek knowledge beyond the outrage cycle"
                  summary="Check out this insightful content on Twygs - a platform for civil discourse and quality journalism."
                  source="Twygs"
                  onClick={handleCountShare}
                >
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    src={LinkedinIcon}
                    alt="icon"
                  />
                </LinkedinShareButton>
                <WhatsappShareButton
                  url={shareUrl}
                  windowWidth={700}
                  title="Check out this article on Twygs"
                  windowHeight={600}
                  separator=" "
                  onClick={handleCountShare}
                >
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    src={WhatsappIcon}
                    alt="icon"
                  />
                </WhatsappShareButton>
                <RedditShareButton
                  url={shareUrl}
                  title="Check out this article on Twygs"
                  onClick={handleCountShare}
                >
                  <Image
                    _hover={{
                      opacity: 0.8
                    }}
                    w={'24px'}
                    src={RedditIcon}
                    alt="icon"
                  />
                </RedditShareButton>
              </div>
            </div>
            <p className="px-3 mt-[10px] text-center italic text-02-dim-gray text-xs">
              {description ??
                'Share article on social media or copy the link below to send it directly to your audience.'}
            </p>

            <div className="p-2 mt-4 bg-05-seasalt-white rounded-[12px] flex items-center justify-between gap-4 w-full">
              <Link href={shareUrl} target="_blank">
                <Text
                  isTruncated
                  w={'100%'}
                  maxW={{ base: '210px', md: '257px' }}
                  fontSize={'sm'}
                  fontWeight={600}
                  color={'#012BC2'}
                  _hover={{ cursor: 'pointer' }}
                >
                  {shareUrl}
                </Text>
              </Link>
              <Box
                display={'flex'}
                alignItems={'center'}
                columnGap={'8px'}
                onClick={handleCopy(shareUrl)}
                cursor="pointer"
              >
                <Text fontSize={'sm'} fontWeight={900} color={'#4CAF50'}>
                  {isCopy ? 'Copied' : 'Copy'}
                </Text>
                <Image src={isCopy ? CopySuccessIcon : CopyGreenIcon} alt="" />
              </Box>
            </div>
          </div>
        </ModalBody>
        <ModalFooter w="100%" p="0">
          <Button
            w="100%"
            variant={'growth-green'}
            fontSize={'md'}
            height={'46px'}
            onClick={onClick}
          >
            {titleBtn}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ShareContentModal;
